<div class="grid-container padding-bottom-4">
  <div class="grid-row grid-gap-1">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-9 desktop:grid-col-9">
      <legend class="usa-legend usa-legend--large">FRT OTO Bids</legend>
    </div>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
    <ag-grid-angular class="ag-theme-alpine" [gridOptions]="otoBidsGridOptions" [rowData]="otoBidsList" [columnDefs]="columnDefs" [suppressDragLeaveHidesColumns]="true">
    </ag-grid-angular>
  </div>
</div>
